// extracted by mini-css-extract-plugin
module.exports = {"header":"login_header__mHIVm","main":"login_main__SvXGN","description":"login_description__jU_50","buttonGroup":"login_buttonGroup__hCX3r"};